import { IIssueFaultTypeChild } from '@kcftech/prometheustypescriptapiclient';
import { NoValue } from 'components/no_value/NoValue';
import { memo, useMemo, useRef } from 'react';
import { HoverTooltip } from 'shared/hover_tooltip/HoverTooltip';
import styled from 'styled-components';
import { sortBy } from 'utils/array';

export const PopupContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;
    width: 36rem;
`;

export const Title = styled.h4`
    margin: 0;
    padding: 0;
    font-size: 1.4rem;
    font-weight: 600;
`;

export const FaultTypesList = styled.ul`
    margin: 0;
    padding-left: 3rem;
    max-height: 20rem;
    overflow-y: auto;
`;

export const FaultType = styled.li`
    white-space: pre-line;
    flex-wrap: wrap;
    overflow-wrap: anywhere;
    font-size: 1.4rem;
    margin: 0.25rem 0rem;
`;

export const FaultTypesContainer = styled.div``;

export const NoValueContainer = styled.div`
    &.no-value {
        text-decoration: none;
    }
`;

export type IssueFaultTypesDisplayProps = Readonly<{
    faultTypes: IIssueFaultTypeChild[];
    className?: string;
}>;

function IssueFaultTypesDisplayBase({
    faultTypes,
    className,
}: IssueFaultTypesDisplayProps) {
    const anchorRef = useRef<HTMLDivElement>(null);

    const sortedFaultTypes = useMemo(
        () => sortBy(faultTypes, ({ FullName }) => FullName),
        [faultTypes]
    );

    if (sortedFaultTypes.length === 0) {
        return (
            <NoValueContainer className="no-value">
                <NoValue />
            </NoValueContainer>
        );
    }

    return (
        <>
            <FaultTypesContainer ref={anchorRef} className={className}>
                {sortedFaultTypes.map(({ FullName }) => FullName).join(', ')}
            </FaultTypesContainer>
            <HoverTooltip anchorRef={anchorRef} stickyHover>
                <PopupContent>
                    <Title>Fault Type</Title>
                    <FaultTypesList>
                        {sortedFaultTypes.map((faultType) => (
                            <FaultType key={faultType.Id}>{faultType.FullName}</FaultType>
                        ))}
                    </FaultTypesList>
                </PopupContent>
            </HoverTooltip>
        </>
    );
}

const memoIssueFaultTypesDisplay = memo(IssueFaultTypesDisplayBase);
export { memoIssueFaultTypesDisplay as IssueFaultTypesDisplay };
